import Layout from "../../components/Layout/Layout";
import { LAYOUT_TYPE } from "../../constants";
import LoginForm from "../../components/LoginForm/LoginForm";

export default function Login() {
  return (
    <Layout type={LAYOUT_TYPE.LOGIN_PAGE}>
      <LoginForm />
    </Layout>
  );
}
